import React from "react";
import { Button, CircularProgress } from "@mui/material";

const defaultFunction = () => {};

export default function SimpleButton({
  children,
  className,
  disabled = false,
  onClick = defaultFunction,
  type,
  color,
  endIcon,
  startIcon,
  fullWidth = false,
  size,
  href,
  variant,
  loading = false,
}) {
  return (
    <Button
      className={className}
      onClick={() => onClick()}
      disabled={disabled}
      variant={variant}
      type={type}
      size={size}
      color={color}
      startIcon={
        loading ? <CircularProgress size="20px" color="white" /> : startIcon
      }
      endIcon={loading ? null : endIcon}
      fullWidth={fullWidth}
      href={href}
    >
      {children}
    </Button>
  );
}
